import React, { useContext, useState } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import TutorialNegotiationModal from '../../Modal/TutorialNegotiationModal';
import NegotiationModalContainer from '../../Modal/NegotiationModalContainer';
import { TradeContext } from '../../../_shared/types/trade';
import NegotiationState from '../../../_shared/constants/negotiationState';
import PendingBidBoxFooterContext from '../../Vdp/BidBox/Controls/PendingBidBoxFooterContainer/PendingBidBoxFooterContext';
import UserService from '../../../services/UserService';
import MixpanelService from '../../../services/MixpanelService';
import MixpanelConfig from '../../../_shared/constants/mixpanelConfig';
import { BidSource } from '../../../_shared/types/auction';
import ROUTES from '../../Routes/constants';
import NegotiationService from '../../../services/NegotiationService';
import NegotiationErrorModalContainer from './NegotiationErrorModalContainer';
import useNegotiationTutorialVariant from '../../../_shared/hooks/trade/useNegotiationTutorialVariant';

const RespondNegotiationContainer = ({
  trade,
  Button,
  tradeContext,
  isOmp = false
}) => {
  const {
    id: tradeId,
    auctionId,
    negotiationState: tradeNegotiationState,
    sellingNetworkId,
    associatedTradeId,
    isInternalTrade
  } = trade;
  const { negotiationState: bidBoxNegotiationState, negotiations } = useContext(
    PendingBidBoxFooterContext
  );
  const negotiationState = tradeNegotiationState || bidBoxNegotiationState;

  const [hasTutorial, tutorialVariant] = useNegotiationTutorialVariant(
    tradeContext,
    negotiationState,
    sellingNetworkId,
    associatedTradeId,
    isInternalTrade
  );

  const [
    tutorialNegotiationModalIsOpen,
    setTutorialNegotiationModalIsOpen
  ] = useState(false);
  const [negotiationModalIsOpen, setNegotiationModalIsOpen] = useState(false);
  const [negotiationErrorMessage, setNegotiationErrorMessage] = useState(null);

  const eventSource = window.location.href.includes(ROUTES.TRADE_URI)
    ? BidSource.VDP_OVERLAY
    : BidSource.LIST_VIEW;
  const userService = UserService.get();
  const mixpanel = MixpanelService.get();
  const user = useSelector(state => state?.auth?.user, shallowEqual);
  const isCurrentUserSecondBidder =
    negotiations?.canAccept &&
    tradeContext === TradeContext.Buy &&
    negotiationState === NegotiationState.FINAL_ASKING_PRICE;

  const getUserType = () => {
    if (userService.isSeller(user, trade?.dealer?.id)) {
      return MixpanelConfig.userType.seller;
    }

    if (isCurrentUserSecondBidder) {
      return MixpanelConfig.userType.secondBidder;
    }

    return MixpanelConfig.userType.buyer;
  };

  const [
    isNegotiationErrorModalOpen,
    setIsNegotiationErrorModalOpen
  ] = useState(false);

  const onReplyNegotiationModal = () => {
    if (!isInternalTrade && associatedTradeId) {
      const negotiationService = NegotiationService.get();
      negotiationService.getNegotiationMessage(
        associatedTradeId,
        tradeContext,
        setNegotiationErrorMessage,
        setIsNegotiationErrorModalOpen,
        setTutorialNegotiationModalIsOpen
      );
    }
    if (hasTutorial) {
      setTutorialNegotiationModalIsOpen(true);
    } else {
      setNegotiationModalIsOpen(true);
    }

    mixpanel.track(MixpanelConfig.names.replyToOffer, {
      user_type: getUserType(),
      source: eventSource,
      trade_id: tradeId,
      auction_id: auctionId
    });
  };

  const onCloseNegotiationModal = () => {
    setNegotiationModalIsOpen(false);
  };

  return (
    <>
      <Button onClick={onReplyNegotiationModal} />
      {!hasTutorial || (
        <>
          {isNegotiationErrorModalOpen ? (
            <NegotiationErrorModalContainer
              isNegotiationErrorModalOpen={isNegotiationErrorModalOpen}
              negotiationErrorMessage={negotiationErrorMessage}
              setIsNegotiationErrorModalOpen={setIsNegotiationErrorModalOpen}
              tradeId={tradeId}
              auctionId={auctionId}
            />
          ) : (
            <TutorialNegotiationModal
              modalIsOpen={tutorialNegotiationModalIsOpen}
              onClose={() => {
                setTutorialNegotiationModalIsOpen(false);
              }}
              onStartNegotiation={() => {
                setTutorialNegotiationModalIsOpen(false);
                setNegotiationModalIsOpen(true);
              }}
              variant={tutorialVariant}
            />
          )}
        </>
      )}
      <NegotiationModalContainer
        trade={trade}
        modalIsOpen={negotiationModalIsOpen}
        tradeContext={tradeContext}
        onClose={onCloseNegotiationModal}
        isOmp={isOmp}
      />
    </>
  );
};

export default RespondNegotiationContainer;
